import { lazy, FC, Suspense } from 'react'
import { Route, Routes, Navigate } from 'react-router-dom'
import { MasterLayout } from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import { getCSSVariableValue } from '../../_metronic/assets/ts/_utils'
import { WithChildren } from '../../_metronic/helpers'

const TrainingRoutes = () => {
  const TrainingPage = lazy(() => import('../modules/training/training-management/TrainingPage'))
  const NotificationPage = lazy(() => import('../modules/training/notification-management/NotificationPage'))

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        <Route path='auth/*' element={<Navigate to='/training-management' />} />
        <Route
          path='training-management/*'
          element={
            <SuspensedView>
              <TrainingPage />
            </SuspensedView>
          }
        />
        <Route
          path='notification-management/*'
          element={
            <SuspensedView>
              <NotificationPage />
            </SuspensedView>
          }
        />

        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({ children }) => {
  const baseColor = getCSSVariableValue('--kt-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export { TrainingRoutes }
